import { render } from "./GithubCard.vue?vue&type=template&id=67612190&scoped=true"
import script from "./GithubCard.vue?vue&type=script&lang=js"
export * from "./GithubCard.vue?vue&type=script&lang=js"

import "./GithubCard.vue?vue&type=style&index=0&id=67612190&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67612190"]])

export default __exports__